module.exports = __webpack_public_path__ + "img/1F1FB-1F1E6.a29baf1d.svg";